import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
const routes =  [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login_unit.vue'),
      },
    {
        path: '/',
        component: () => import('@/views/screen/screensInit.vue'),
        name:'screensInit',
    },
    {
        path: '/communityInfo',
        component: () => import('@/views/screen/communityInfo.vue'),
        name:'communityInfo', 
    },
    {   
        path: '/communityManger',
        component: () => import('@/views/screen/communityManger.vue'),
        name:'communityManger', 
    },
    {
        path: '/peopleManger',
        component: () => import('@/views/screen/peopleManger.vue'),
        name:'peopleManger', 
    },
    // {
    //     path: '/testUnit',
    //     component: () => import('@/views/screen/testUnit.vue'),
    //     name:'peopleManger', 
    // }
]
const router = new VueRouter({
    routes
  })    
  export default router